/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import PersonalDetailsPresenter from './PersonalDetailsPresenter';
import Shell from '../../../common/components/Shell/Shell';
import { Grid } from '@mui/material';
import DTOPersonalDetails from './DTOPersonalDetails';
import { useAppDispatch, useAppSelector } from '../../../infra/hooks';
import { useTranslation } from 'react-i18next';
import { commonServices } from '../../../api/services/commonServices';
import { setsignedprofilepic } from '../../../infra/aggregates/profilePicSlice';
interface empDetailProps {
  name: string;
  designation: string;
  profilePic: any;
}
function PersonalDetailsController() {
  const { t, i18n } = useTranslation();
  const [empDetail, setEmpDetail] = useState<empDetailProps>({
    designation: '',
    name: '',
    profilePic: '',
  });

  const isLoading = useAppSelector(
    (state) => state.personalDetailLoaderSlice.PersonalDetailLoading,
  );
  const selector = useAppSelector((state) => state);
  const dispatch = useAppDispatch();
  function callback(data: empDetailProps) {
    setEmpDetail({
      name: data.name,
      designation: data.designation,
      profilePic: data.profilePic,
    });
  }
  const setEmpProPic = (data: any) => {
    if (data) {
      const user_id: any = selector.authSlice.user_id;
      const companyID: any = selector.authSlice.company_id;
      const Payload = {
        filepath: data,
        fullpath: true,
      };
      commonServices
        .getFilePath(companyID, user_id, Payload)
        .then((res: any) => {
          dispatch(setsignedprofilepic(res));
        });
    }
  };

  return (
    <Shell>
      <Grid
        container
        style={{
          maxWidth: 'auto',
          marginLeft: i18n.language == 'en' ? '7.25em' : '',
        }}
      >
        <DTOPersonalDetails
          setEmpNameDesignation={callback}
          getempProPic={setEmpProPic}
        />
        <PersonalDetailsPresenter
          employeeDetail={empDetail}
          isLoading={isLoading}
          trans={t}
          i18n={i18n}
        />
      </Grid>
    </Shell>
  );
}
export default PersonalDetailsController;
